export type { AssetsPickerOption, Props as AssetsPickerProps } from './assets-picker-dumb';
export { default as AssetsPickerDumb } from './assets-picker-dumb';
